/**
 * 常用函数封装
 */
import { usePermissionStoreWithOut } from '/@/store/modules/permission'
import {getTenantId, getToken} from "/@/utils/auth";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { PrjExecutorType, PrjInitTypeEnum } from "/@/enums/configEnum";
import {getDictLabel, getTaskTypeParentType} from "/@/views/project/project.util";
const permissionStore = usePermissionStoreWithOut()
import Decimal from 'decimal.js'
import {useUserStore} from '/@/store/modules/user';
import { getServerSysConfigByKey } from "/@/utils/dict";
import { usePermission } from '/@/hooks/web/usePermission';
import { queryMyPrjManagerAuthFetch } from '/@/api/project/project';

const userStore = useUserStore()
/**
 * 文件大小按格式显示，参数为字节大小b
 * @param {*} size
 */
export function formatFileSize(size=0) {
  let result = Number(size);
  let unit = ['B', 'KB', 'MB', 'GB', 'TB', 'ZB']
  let i = 0;
  while (result > 1024) {
    result /= 1024
    i++;
  }
  return result.toFixed(2) + unit[i];
}

/**
 * 文件名分离，参数为文件全名,第二个参数不传则返回名称及扩展，传name或ext获取对应值
 * @param {*} fileFullName,key
 */
export function getFileExtensionAndName(fileFullName, key = 'all') {
  let index = fileFullName.lastIndexOf('.');
  if (key === 'name') {
    return fileFullName.substr(0, index);
  } else if (key === 'ext') {
    return fileFullName.substr(index + 1);
  } else {
    return {
      name: fileFullName.substr(0, index),
      ext: fileFullName.substr(index + 1)
    };
  }

}

/**
 * 文件名分离，参数为上传的文件item
 * @param {*} item
 */
export function formatFileName(item){
  if(!item||!item.fileType||!item.fileName){
    return ;
  }

  let fileName =String(item.fileName);
  let index = fileName.lastIndexOf('.');
  if(index!==-1){
    let ext =fileName.substr(index + 1)
    // 大小写不敏感比较：避免 fileName 已含该扩展名时被重复拼接（如 x.MP4 + mp4）
    if(ext.toLowerCase()!==String(item.fileType).toLowerCase()){
      fileName=fileName+'.'+item.fileType;
    }
  }else{
    fileName=fileName+'.'+item.fileType;
  }
  return fileName;
}

/**
 * 姓名脱敏
 * @param {*} name
 */
// export function nameFormat(name) {
//   if (name?.length > 2) {
//     let replaceStr = `$1${ new Array(name.length-2).fill('*').join('')}$2`
//     return name.replace(/^(.).+(.)/, replaceStr)
//   } else {
//     return name?.replace(/^(.).+/,"$1*") ?? ''
//   }
// }

/**
 * 姓名脱敏
 * @param {*} name
 */
export function nameFormat(name) {
  if (name?.length > 2) {
    let replaceStr = `$1${ new Array(name.length-1).fill('*').join('')}`
    return name.replace(/^(.).+(.)/, replaceStr)
  } else {
    return name?.replace(/^(.).+/,"$1*") ?? ''
  }
}

/**
 * 发布信息转换
 * @param {string} status 状态
 * @param {string} release 是否发布 1 发布 0 未发布
 * @param {string} statusName 需要展示 发布信息的状态 默认 approve_pass
 */
export function transPublish(status, release, statusName='approve_pass') {
  if(status == statusName){
    return release == 1 ? '企业官网' : '未发布'
  }
  return '--'
}

/**
 * 检测是否含有style标签
 * @param {string} str 检测的字符串
 */
export function hasStyleTag(str='') {
  return /<style(([\s\S])*?)<\/style>/g.test(str);
}
/**
 * 检测是否为空值
 * @param value
 */
export function isEmptyValue(value) {
  return ['',null,undefined].includes(value);
}


/*
* 校验是否配置价格类型权限功能按钮权限
*@param {string} 价格权限
*
* */

export function  hasPriceTypePermission  (priceType){
  let { sysRolePriceList } = permissionStore
  if(!priceType || !sysRolePriceList || !sysRolePriceList.length){
    return false;
  }
  let priceTypeArr = sysRolePriceList.map((item) => {return item?.authCode})
  // console.log(priceTypeArr.includes(priceType))
  return priceTypeArr.includes(priceType)
}

/*
* 是否显示任务销售单价/采购单价
* @param {string} type 单价类型
* @param {string} priceData 角色权限数据
* @param isAssistUserId 是否是协助人
* @param isCreateId 是否是创建人
* @param isTaskCreateId 是否是任务创建人
* @param isTaskManagerId 是否是任务负责人
* */
export function getFieldPriceResultByRole(type,priceData) {
    if(type == 'unitPrice'){
      if(priceData?.prjInitiationType == 'self_prj_init'){
        return false;
      }
      return hasPriceTypePermission('priceType:sellingPrice') || !!priceData?.isCreateId || !!priceData?.isTaskCreateId || !!priceData?.isTaskManagerId
    }
    if(type == 'actualUnitPrice'){
      return hasPriceTypePermission('priceType:purchasePrice') || !!priceData?.isAssistUserId || !!priceData?.isCreateId || !!priceData?.isTaskManagerId
    }
    return false
}

// 是否显示交付物销售单价/采购单价
export function getDeliverFieldPriceResultByRole(type,priceData) {
  if(type == 'unitPrice'){
    if(priceData?.prjInitiationType == 'self_prj_init' || userStore.isOutsourcerUser){
      return false;
    }
    return hasPriceTypePermission('priceType:sellingPrice') || priceData?.isTaskCreateId || priceData?.isTaskManagerId || priceData?.isTaskCreator || priceData?.isTaskManager
  }
  if(type == 'actualUnitPrice'){
    return hasPriceTypePermission('priceType:purchasePrice') || priceData?.isAssistUserId || priceData?.isCreateId || priceData?.isTaskManagerId || priceData?.isAssistUser || priceData?.isCreator || priceData?.isTaskManager
  }

  if (type == 'serverLevel') {
    return priceData?.prjInitiationType == 'info_prj_init' && !userStore.isOutsourcerUser ? true : false
  }

  return false
}

// 是否市场推广项目
export function isInfoPrjType(priceData) {
  return priceData?.prjInitiationType == 'info_prj_init' ? true : false
}

/*
* 数值计算，解决精度问题
* */
export function numberCalculate(num1, num2, rule = '+') {
  var sq1;
  var sq2;
  var m;

  try {
    sq1 = num1.toString().split('.')[1].length;
  } catch (e) {
    sq1 = 0;
  }
  try {
    sq2 = num2.toString().split('.')[1].length;
  } catch (e) {
    sq2 = 0;
  }
  m = Math.pow(10, Math.max(sq1, sq2));
  const ruleType = {
    "+": (num1 * m + num2 * m) / m,
    "-": (num1 * m - num2 * m) / m,
    "*": (num1 * m) * (num2 * m) / (m * m),
    "/": num1 * m / (num2 * m)
  };
  return ruleType[rule]!=ruleType[rule]?0.00:ruleType[rule].toFixed(2);
}

/*
* 使用Decimal计算
* @param {string} num1 数值1
* @param {string} num2 数值2
* @param {string} rule 运算规则 add 加法 sub 减法  times 乘法  div 除法
* @param {string} decimal 保留小数位数
* */
export function decimalCalculate(num1, num2, rule = 'add', decimal=null) {
  let numDecimal1 = new Decimal(num1 || 0);
  let numDecimal2 = new Decimal(num2 || 0);
  if (!num2 && rule == 'div') {
    return null
  }
  const result = numDecimal1[rule](numDecimal2)
  if (decimal) {
    return result.toFixed(decimal)
  } else {
    return result.toFixed()
  }

}

//判断对象key是否全部为空
export function objHasFieldsValueFn(data) {
  if(typeof data !== 'object'){return false}
  let fieldArr = Object.keys(data);
  let isEmptyObjFlag = false;
  fieldArr.forEach(item => {
    if(data[item] || data[item] == 0){
      isEmptyObjFlag = true
    }
  })
  return isEmptyObjFlag
}

// 获取报表预览地址
export function getJiMuReportPreviewUrl(id,bizId=null){
  let token = getToken();
  let tenantId = getTenantId();
  let url=`${window._CONFIG['domianURL']}/jmreport/view/${id}?token=${token}&tenantId=${tenantId}`;
  if(bizId){
    url= `${url}&bizId=${bizId}`;
  }
  return  url;
}

//展示已结账的modal提示
export function showBillMsg(params) {
  const titleMap = {
    prj: '项目',
    plan: '计划',
    task: '任务',
  }
  Modal.warning({
    title: () => `删除${titleMap[params.type]}`,
    centered: true,
    icon: () => createVNode(ExclamationCircleOutlined, {style: {color:'red'}}),
    content: `该${titleMap[params.type]}下存在交付物已被平台结账，不可删除，如有疑问，可联系客服`,
  });
}
/*
* 判断是否是自营项目
* */

export function isSelfPrj(prjInfo){
  return prjInfo?.prjInitiationType == PrjInitTypeEnum.SELF_PRJ_INIT
}
/*
*
* 基于项目信息获取动态项目类型、所在方、合作机构
* */
export function getProjectDynamicInfo(prjInfo){
  let tenantId = getTenantId();
  let cooperativeAgency = getCooperativeAgency(prjInfo,true);
  let cooperativeAgencyId = getCooperativeAgencyId(prjInfo,true);
  let belongUnit = 'receiver'; //自营默认为承接方（用于交付物操作按钮判断）
  let prjInitiationTypeName = prjInfo?.prjInitiationType ? getDictLabel(prjInfo.prjInitiationType,'prj_init_type'):'';
  let isCreateUnit = tenantId === prjInfo?.tenantId || !prjInfo?.tenantId;
  let isSelfProject = isSelfPrj(prjInfo);
  // 非自营立项
  if(prjInfo?.prjInitiationType&&!isSelfProject){
      // 所在方是委托方
    if(tenantId === prjInfo?.initiatorTenantId){
      belongUnit = 'initiator';
      prjInitiationTypeName = getDictLabel(PrjInitTypeEnum.ENTRUST_PRJ_INIT,'prj_init_type');
    }else{
      // 所在方是承接方
      belongUnit = 'receiver';
      prjInitiationTypeName = getDictLabel(PrjInitTypeEnum.INFO_PRJ_INIT,'prj_init_type');
    }
  }

  return {
    isCreateUnit: isCreateUnit, // 是否是创建方
    prjInitiationTypeName: prjInitiationTypeName, // 动态立项类型label
    belongUnit: belongUnit,  //所在方
    cooperativeAgencyId: cooperativeAgencyId,  //合作机构id
    cooperativeAgency: cooperativeAgency,  //合作机构
    isReceiver: belongUnit === 'receiver', // 是否是承接方
    isSelfProject: isSelfProject,  //是否是自营项目
    isOutsider: prjInfo?.prjExecutorType == PrjExecutorType.OUTSIDER,
  }
}

/*
* 基于项目信息获取交付物的动态合作机构信息
* */
export function getCooperativeAgencyId(prjInfo,isProject=false){
  if (!prjInfo){
    return '';
  }
  let tenantId = getTenantId();
  let id = isProject ? '' : prjInfo?.initiatorId;
  if(prjInfo?.prjInitiationType && !isSelfPrj(prjInfo)){
    // 所在方是委托方
    if(tenantId === prjInfo.initiatorTenantId){
      // 合作机构为承接方
      id = prjInfo.receiverAgencyId;
    }else{
      // 所在方是承接方
      // 合作机构为委托方
      id = prjInfo.initiatorId;
    }
  }
  return id
}

/*
*
* 基于项目信息获取交付物的动态合作机构信息
* */
export function getCooperativeAgency(prjInfo,isProject=false){
  if (!prjInfo){
    return '-';
  }
  let tenantId = getTenantId();
  let cooperativeAgency = isProject ? '-' : prjInfo?.initiatorName;
  if(prjInfo?.prjInitiationType&&!isSelfPrj(prjInfo)){
    // 所在方是委托方
    if(tenantId === prjInfo.initiatorTenantId){
      // 合作机构为承接方
      cooperativeAgency = prjInfo.receiverName;
    }else{
      // 所在方是承接方
      // 合作机构为委托方
      cooperativeAgency = prjInfo.initiatorName;
    }
  }
  return cooperativeAgency
}

/*
*
* 基于项目信息获取合作方负责人信息
* */
export function getProjectDynamicPartnerManager(prjInfo){
  let {isReceiver} = getProjectDynamicInfo(prjInfo);
  return {
    managerName: isReceiver ? prjInfo.initiatorManager : prjInfo.receiverManager,
    managerPhone: isReceiver ? prjInfo.initiatorPhone : prjInfo.receiverPhone,
    managerEmail: isReceiver ? prjInfo.initiatorEmail : prjInfo.receiverEmail,
  }
}
/*
*
* 基于项目信息获取己方负责人信息
* */
export function getProjectDynamicManagerInfo(prjInfo){
  let {isReceiver}=getProjectDynamicInfo(prjInfo);
  return {
    managerName: !isReceiver ? prjInfo.initiatorManager : prjInfo.receiverManager,
    managerPhone: !isReceiver ? prjInfo.initiatorPhone : prjInfo.receiverPhone,
    managerEmail: !isReceiver ? prjInfo.initiatorEmail : prjInfo.receiverEmail,
  }
}

/*
*
* 基于项目所在方获取业务状态；
* @param projectInfoBaseVO 项目封装的信息
* @param detailInfo 业务详情
* @return {status,todoUser},返回基于身份后的状态码及待办人
* */
export function getDynamicStatus(projectInfoBaseVO,detailInfo){
  let {isReceiver}=getProjectDynamicInfo(projectInfoBaseVO);
  return {
    status: isReceiver?detailInfo.status:detailInfo.initiatorStatus,
    todoUser: isReceiver?detailInfo.todoUser:detailInfo.initiatorTodoUser,
    arriveTime: isReceiver?detailInfo.currentApprovalArriveTime:detailInfo.receiverApprovalArriveTime,
  }
}

/*
*
* 基于项目所在方获取结算单业务状态；
* @param projectInfoBaseVO 项目封装的信息
* @param detailInfo 业务详情
* @return {status,todoUser},返回基于身份后的状态码及待办人
* */
export function getDynamicStatementStatus(projectInfoBaseVO,detailInfo){
  let {isReceiver}=getProjectDynamicInfo(projectInfoBaseVO);
  return {
    status: isReceiver?detailInfo.status:detailInfo.statementIndustryStatus,
    todoUser: isReceiver?detailInfo.todoUser:detailInfo.initiatorTodoUser,
    arriveTime: isReceiver?detailInfo.currentApprovalArriveTime:detailInfo.industryApprovalArriveTime,
  }
}

export function formatApprovalDuration(currentApprovalArriveTime) {
  if (!currentApprovalArriveTime) {
    return ''
  }
  const arriveTime = new Date(currentApprovalArriveTime).getTime()
  if (Number.isNaN(arriveTime)) {
    return ''
  }
  const diff = Date.now() - arriveTime
  if (diff < 0) {
    return ''
  }
  const minuteMs = 60 * 1000
  const hourMs = 60 * minuteMs
  const dayMs = 24 * hourMs
  const days = Math.floor(diff / dayMs)
  if (days >= 1) {
    const hours = Math.floor((diff % dayMs) / hourMs)
    return `${days}天${hours}小时`
  }
  const hours = Math.floor(diff / hourMs)
  const minutes = Math.floor((diff % hourMs) / minuteMs)
  return `${hours}小时${minutes}分钟`
}

export function formatApprovalStatusText(statusText, todoUser, currentApprovalArriveTime) {
  if (!todoUser) {
    return statusText
  }
  const durationText = formatApprovalDuration(currentApprovalArriveTime)
  return durationText ? `${statusText}-${todoUser}：${durationText}` : `${statusText}-${todoUser}`
}

// 将数字转换为大写金额
export const convertToUppercasePrice = (n) => {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['圆', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  const head = n < 0 ? '欠' : '';
  n = Math.abs(n);

  let s = '';

  for (let i = 0; i < fraction.length; i++) {
    const num = decimalCalculate(decimalCalculate(n, 10, 'times'),  Math.pow(10, i), 'times')
    s += (digit[Math.floor(num) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(decimalCalculate(n, 10, 'div'));
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零圆/, '圆').replace(/(零.)+/g, '零').replace(/^整$/, '零圆整');
}

export const getPriceByQuality = (taskType) => {
  const { hasTenantPermission } = usePermission()
  const priceByQuality = hasTenantPermission('priceByQuality')
  const priceByQualityTaskType = getServerSysConfigByKey('priceByQualityTaskType')?.split(',') ?? []
  return priceByQuality && priceByQualityTaskType.includes(taskType)
}

/**
 * 查询当前用户在指定项目下的管理人员功能权限列表
 * 用于接口未返回 managerAuthList 的页面，返回结果可直接交给 hasPermissionList 判权
 */
export async function getPrjManagerAuthList(prjId?: string | number) {
  if (!prjId) {
    return [];
  }
  const res = await queryMyPrjManagerAuthFetch({ prjId });
  return res || [];
}
